import {useDispatch} from 'react-redux'
import {
	useMerchandiseOrder,
	useMerchandiseItem
} from '../hooks'
import Badge from 'react-bootstrap/Badge'
import Form from 'react-bootstrap/Form'
import {useClient} from '../../users/hooks'
import useCurrentUser from '../../../hooks/useCurrentUser'
import {dateToYMD,dateToAPIStandard} from '../../../util/datetime'
import {editMerchandiseOrderStatus} from '../slice'
import styles from './Order.module.css'
import {getCurrencySymbol} from '../../../util/intl'

const LineItem = ({qty,item})=>(
	<div className={[
		"d-flex align-items-center px-2 pt-2 pb-0",
		styles.LineItem
	].join(' ')}>
		<div className={styles.ItemName}>
			{item.title}
		</div>
		<div className="mr-2 d-flex align-items-center">
			<small className="text-muted mr-1">x</small> {qty}
		</div>
	</div>
)

const Order = ({id})=>{
	const dispatch = useDispatch()
	const user = useCurrentUser()
	const {order} = useMerchandiseOrder(id)
	const purchaser = useClient(order.purchaser_id)
	const handleToggleStatus = e => {
		const fulfilled = Number(e.target.checked)
		const fulfilled_on = dateToAPIStandard(new Date())
		dispatch(editMerchandiseOrderStatus({id,fulfilled,fulfilled_on}))
	}
	if(!purchaser||!order) return null
	return (
		<div className={styles.Order}>
			<div className="text-right pr-2">
				{
					user.account_type === 'client' ? 
					<small>
						<Badge variant={Boolean(order?.fulfilled)?'success':'danger'}>
							{Boolean(order?.fulfilled)?'Fulfilled':'Open'}
						</Badge>
					</small>
					:
					<Form.Check 
						checked={Boolean(order?.fulfilled)} 
						onChange={handleToggleStatus}
					/>
				}
			</div>
			{order.line_items.map(line_item=>(
				<LineItem key={line_item.id} qty={line_item.qty} item={line_item.item}/>
			))}
			<div className="px-2 pb-1 pt-1 d-flex justify-content-between">
				{user.account_type!=='client'&&
					<small>
						Client: {purchaser?.user_name}
					</small> 
				}
				<div className="ml-auto">
					<small className="text-muted d-block">
						Ordered on: {(new Date(order.ordered_on?.split(' ').join('T'))).toLocaleDateString()}
					</small>
					{Boolean(order.fulfilled)&&
						<small className="text-muted d-block">
							Fulfilled on: {(new Date(order.fulfilled_on?.split(' ').join('T'))).toLocaleDateString()}
						</small>
					}
				</div>
			</div>
		</div>
	)
}

export default Order